module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/exportDataHoverCM.f841e438.svg";